import React from "react";
import "./TourPackagesViewMore.css";
import { useNavigate } from "react-router-dom";
import shimla from "../../assets/shimla.jpg";
import udaipur from "../../assets/udaipur.jpg";
import jaisalmer from "../../assets/jaisalmer.jpg";
import manali from "../../assets/manali.png";
import goa from "../../assets/goa.png";
import kerala from "../../assets/kerala.png";
import ooty from "../../assets/ooty.png";
import darjeeling from "../../assets/darjeeling.png";
import andaman from "../../assets/andaman.png";
import jaipur from "../../assets/jaipur.png";
import rishikesh from "../../assets/rishikesh.png";
import ladakh from "../../assets/ladakh.png";
import spiti from "../../assets/spiti.png";
import kasol from "../../assets/kasol.png";
import meghalaya from "../../assets/meghalaya.png";
import varanasi from "../../assets/varanasi.png";
import rameshwaram from "../../assets/rameshwaram.png";
import tirupati from "../../assets/tirupati.png";
import pkg1 from "../../assets/pkg1.png";
import pkg2 from "../../assets/pkg2.png";
import pkg3 from "../../assets/pkg3.png";
import pkg4 from "../../assets/pkg4.png";
import pkg5 from "../../assets/pkg5.png";
import pkg6 from "../../assets/pkg6.png";

import coorg from "../../assets/coorg.png";

import delhiagra from "../../assets/delhiagra.png";
import delhiudaipur from "../../assets/delhiudaipur.png";
import delhirishikesh from "../../assets/delhirishikesh.png";
import delhimandu from "../../assets/delhimandu.png";
import delhishimla from "../../assets/delhishimla.png";
import nityanjali from "../../assets/nityanjali.png";
import chathpuja from "../../assets/chathpuja.png";
import ramnavami from "../../assets/ramnavami.png";
import durgapuja from "../../assets/durgapuja.png";
import ranthambore from "../../assets/ranthambore.png";
import pondicherry from "../../assets/pondicherry.png";
import mysore from "../../assets/mysore.png";
import waterpark from "../../assets/waterpark.png";
import gamingzone from "../../assets/gamingzone.png";
import adventurepark from "../../assets/adventurepark.png";

import delhi from "../../assets/delhi.png";

import kashmir from "../../assets/kashmir.png";

import agra from "../../assets/agra.png";
import ManaliSoloEscape from "../../assets/ManaliSoloEscape.png";
import RishikeshRetreat from "../../assets/RishikeshRetreat.png";
import GoaBackpacking from "../../assets/GoaBackpacking.png";
import LadakhRoadAdventure from "../../assets/LadakhRoadAdventure.png";
import DarjeelingHillsWalk from "../../assets/DarjeelingHillsWalk.png";
import PondicherryExplorer from "../../assets/PondicherryExplorer.png";


import ttvsolo from "../../assets/ttvsolo.png";
import ttvgroup from "../../assets/ttvgroup.png";
import ttvfamily from "../../assets/ttvfamily.png";
import ttvbackpacking from "../../assets/ttvbackpacking.png";
import ttvbeach from "../../assets/ttvbeach.png";
import ttvadventure from "../../assets/ttvadventure.png";
import ttvcorporate from "../../assets/ttvcorporate.png";
import ttvhill from "../../assets/ttvhill.png";
import ttvhoneymoon from "../../assets/ttvhoneymoon.png";
import ttvluxury from "../../assets/ttvluxury.png";
import ttvroad from "../../assets/ttvroad.png";
import ttvweekend from "../../assets/ttvweekend.png";
import ttvwild from "../../assets/ttvwild.png";
import ttvspiritual from "../../assets/ttvspiritual.png";
import ttvfestival from "../../assets/ttvfestival.png";
import ttvcouple from "../../assets/ttvcouple.png";
import rtour from "../../assets/rtour.png";
import stour from "../../assets/stour.png";
import gtour from "../../assets/gtour.png";
import etour from "../../assets/etour.png";
import holi from "../../assets/holi.png";
import eid from "../../assets/eid.png";
import christmas from "../../assets/christmas.png";
import gurunanak from "../../assets/gurunanak.png";
import wtour from "../../assets/wtour.png";
import ftour from "../../assets/ftour.png";
import fetour from "../../assets/fetour.png";
import htour from "../../assets/htour.png";
import ctour from "../../assets/ctour.png";
import rotour from "../../assets/rotour.png";
import HillStationRetreat from "../../assets/HillStationRetreat.png";
import BeachsideFamilyEscape from "../../assets/BeachsideFamilyEscape.png";
import ThemeParkAdventure from "../../assets/ThemeParkAdventure.png";
import CulturalHeritageTour from "../../assets/CulturalHeritageTour.png";
import WildlifeNatureTrip from "../../assets/WildlifeNatureTrip.png";
import CountrysideFarmStay from "../../assets/CountrysideFarmStay.png";
import MountainAdventureCamp from "../../assets/MountainAdventureCamp.png";
import CityExplorationTour from "../../assets/CityExplorationTour.png";
import BeachFunGetaway from "../../assets/BeachFunGetaway.png";
import WildlifeSafariTrip from "../../assets/WildlifeSafariTrip.png";
import IslandHoppingTour from "../../assets/MountainAdventureCamp.png";
import CulturalHeritageJourney from "../../assets/CulturalHeritageJourney.png";
import MaldivesRomanticEscape from "../../assets/MaldivesRomanticEscape.png";
import ParisLoveJourney from "../../assets/ParisLoveJourney.png";
import BaliBlissRetreat from "../../assets/BaliBlissRetreat.png";
import SantoriniSunsetRomance from "../../assets/SantoriniSunsetRomance.png";
import SwissAlpineGetaway from "../../assets/SwissAlpineGetaway.png";
import HawaiiIslandRomance from "../../assets/HawaiiIslandRomance.png";
import MountainTrekkingExpedition from "../../assets/MountainTrekkingExpedition.png";
import RiverRaftingAdventure from "../../assets/RiverRaftingAdventure.png";
import DesertSafariExperience from "../../assets/DesertSafariExperience.png";
import ScubaDivingJourney from "../../assets/ScubaDivingJourney.png";
import ForestCampingRetreat from "../../assets/ForestCampingRetreat.png";
import SkydivingThrill from "../../assets/SkydivingThrill.png";
import MaldivesPrivateVilla from "../../assets/MaldivesPrivateVilla.png";
import DubaiRoyalExperience from "../../assets/DubaiRoyalExperience.png";
import SwissLuxuryRetreat from "../../assets/SwissLuxuryRetreat.png";
import ParisEliteGetaway from "../../assets/ParisEliteGetaway.png";
import BaliPremiumResortStay from "../../assets/BaliPremiumResortStay.png";
import SantoriniLuxuryEscape from "../../assets/SantoriniLuxuryEscape.png";
import CozyHillStationEscape from "../../assets/CozyHillStationEscape.png";
import BeachsideRelaxation from "../../assets/BeachsideRelaxation.png";
import CountrysideFarmRetreat from "../../assets/CountrysideFarmRetreat.png";
import CityBreakAdventure from "../../assets/CityBreakAdventure.png";
import LakeviewSerenityTrip from "../../assets/LakeviewSerenityTrip.png";
import ForestCampingGetaway from "../../assets/ForestCampingGetaway.png";
import CoastalHighwayDrive from "../../assets/CoastalHighwayDrive.png";
import MountainPassAdventure from "../../assets/MountainPassAdventure.png";
import DesertExplorationJourney from "../../assets/DesertExplorationJourney.png";
import CountrysideScenicRoute from "../../assets/CountrysideScenicRoute.png";
import ForestTrailDrive from "../../assets/ForestTrailDrive.png";
import LakeviewRoadEscape from "../../assets/LakeviewRoadEscape.png";
import HimalayanBudgetTrek from "../../assets/HimalayanBudgetTrek.png";
import SoutheastAsiaExplorer from "../../assets/SoutheastAsiaExplorer.png";
import EuropeanRailJourney from "../../assets/EuropeanRailJourney.png";
import CoastalBackpackTrail from "../../assets/CoastalBackpackTrail.png";
import DesertNomadRoute from "../../assets/DesertNomadRoute.png";
import SouthAmericanAdventure from "../../assets/SouthAmericanAdventure.png";
import VaranasiSpiritualJourney from "../../assets/VaranasiSpiritualJourney.png";
import GoldenTempleVisit from "../../assets/GoldenTempleVisit.png";
import KedarnathPilgrimage from "../../assets/KedarnathPilgrimage.png";
import TirupatiTempleTour from "../../assets/TirupatiTempleTour.png";
import MeccaUmrahJourney from "../../assets/MeccaUmrahJourney.png";
import BodhGayaMeditationTour from "../../assets/BodhGayaMeditationTour.png";
import AfricanSavannahSafari from "../../assets/AfricanSavannahSafari.png";
import RanthamboreTigerSafari from "../../assets/RanthamboreTigerSafari.png";
import KazirangaWildlifeExpedition from "../../assets/KazirangaWildlifeExpedition.png";
import AmazonRainforestJourney from "../../assets/AmazonRainforestJourney.png";
import JimCorbettJungleSafari from "../../assets/JimCorbettJungleSafari.png";
import SerengetiMigrationTour from "../../assets/SerengetiMigrationTour.png";
import MaldivesEscape from "../../assets/MaldivesEscape.png";
import GoaBeachRetreat from "../../assets/GoaBeachRetreat.png";
import BaliParadise from "../../assets/BaliParadise.png";
import PhuketAdventure from "../../assets/PhuketAdventure.png";
import SantoriniSeaside from "../../assets/SantoriniSeaside.png";
import HawaiiCoastalBliss from "../../assets/HawaiiCoastalBliss.png";
import ManaliMountainEscape from "../../assets/ManaliMountainEscape.png";
import ShimlaHeritageRetreat from "../../assets/ShimlaHeritageRetreat.png";
import OotyScenicHillsTour from "../../assets/OotyScenicHillsTour.png";
import DarjeelingTeaParadise from "../../assets/DarjeelingTeaParadise.png";
import MunnarGreenValleyEscape from "../../assets/MunnarGreenValleyEscape.png";
import NainitalLakeViewHoliday from "../../assets/NainitalLakeViewHoliday.png";
import GoaTeamBuildingRetreat from "../../assets/GoaTeamBuildingRetreat.png";
import RishikeshLeadershipCamp from "../../assets/RishikeshLeadershipCamp.png";
import LonavalaConferenceEscape from "../../assets/LonavalaConferenceEscape.png";
import JaipurBusinessNetworkingTour from "../../assets/JaipurBusinessNetworkingTour.png";
import KeralaBackwaterStrategyRetreat from "../../assets/KeralaBackwaterStrategyRetreat.png";
import ManaliCorporateAdventureMeet from "../../assets/ManaliCorporateAdventureMeet.png";
import ParisRomanticEscape from "../../assets/ParisRomanticEscape.png";
import MaldivesBeachGetaway from "../../assets/MaldivesBeachGetaway.png";
import SantoriniSunsetRetreat from "../../assets/SantoriniSunsetRetreat.png";
import VeniceGondolaExperience from "../../assets/VeniceGondolaExperience.png";
import BaliTropicalRomance from "../../assets/BaliTropicalRomance.png";
import SwissAlpsLoveJourney from "../../assets/SwissAlpsLoveJourney.png";
import RioCarnivalCelebration from "../../assets/RioCarnivalCelebration.png";
import DiwaliFestivalTour from "../../assets/DiwaliFestivalTour.png";
import OktoberfestMunichExperience from "../../assets/OktoberfestMunichExperience.png";
import HoliColorFestivalJourney from "../../assets/HoliColorFestivalJourney.png";
import CherryBlossomFestivalJapan from "../../assets/CherryBlossomFestivalJapan.png";
import LaTomatinaFestivalTrip from "../../assets/LaTomatinaFestivalTrip.png";
const packages = [
    {
        title: "Rio Carnival Celebration",
        img: RioCarnivalCelebration, 
        desc:
          "Experience the vibrant energy of Rio Carnival with dazzling parades, colorful costumes, lively samba music, and exciting street celebrations.",
       link: "/tour-package-data"
  },
      {
        title: "Diwali Festival Tour",
        img: DiwaliFestivalTour,
        desc:
          "Celebrate the Festival of Lights with sparkling decorations, traditional rituals, delicious sweets, and joyful gatherings. ",
      link: "/tour-package-data"
  },
      {
        title: "Oktoberfest Munich Experience",
        img:OktoberfestMunichExperience,
        desc:
          "Join the lively Oktoberfest celebration in Munich filled with traditional music, festive tents, cultural performances, and delicious Bavarian cuisine.",
       link: "/tour-package-data"
  },
      {
        title: "Holi Color Festival Journey",
        img: HoliColorFestivalJourney,
        desc:
          "Immerse yourself in the colorful celebrations of Holi with joyful gatherings, vibrant powders, music, and festive dances. ",
       link: "/tour-package-data"
  },
      {
        title: "Cherry Blossom Festival Japan",
        img:CherryBlossomFestivalJapan,
        desc:
          "Witness the beauty of cherry blossoms in full bloom across scenic parks and streets in Japan.",
       link: "/tour-package-data"
  },
      {
        title: "La Tomatina Festival Trip",
        img: LaTomatinaFestivalTrip,
        desc:
          "Participate in the thrilling La Tomatina festival filled with fun, laughter, and energetic crowds. ",
      link: "/tour-package-data"
  },
    {
        title: "Paris Romantic Escape",
        img: ParisRomanticEscape,
        desc:
          "Experience magical moments in Paris with scenic river cruises, charming cafes, and iconic landmarks. ",
       link: "/tour-package-data"
  },
      {
        title: "Maldives Beach Getaway",
        img: MaldivesBeachGetaway,
        desc:
          "Relax in luxurious overwater villas surrounded by crystal clear waters in Maldives. ",
       link: "/tour-package-data"
  },
      {
        title: "Santorini Sunset Retreat",
        img: SantoriniSunsetRetreat,
        desc:
          "Admire breathtaking sunsets over whitewashed buildings in Santorini. ",
       link: "/tour-package-data"
  },
      {
        title: "Venice Gondola Experience",
        img:VeniceGondolaExperience ,
        desc:
          "Sail through picturesque canals of Venice on a classic gondola ride. ",
       link: "/tour-package-data"
  },
    {
        title: "Bali Tropical Romance",
        img: BaliTropicalRomance,
        desc:
            "Enjoy serene beaches, lush landscapes, and peaceful resorts in Bali. ",
     link: "/tour-package-data"
  },
      {
        title: "Swiss Alps Love Journey",
        img:SwissAlpsLoveJourney,
       desc:
          "Explore the majestic Swiss Alps with scenic train rides and snow covered peaks. ",
       link: "/tour-package-data"
  },
     {
        title: "Goa Team Building Retreat",
        img: GoaTeamBuildingRetreat,
        desc:
          "Strengthen teamwork and collaboration with engaging activities on Goa beautiful beaches. ",
       link: "/tour-package-data"
  },
      {
        title: "Rishikesh Leadership Camp",
        img: RishikeshLeadershipCamp,
        desc:
          "Enhance leadership skills through adventure activities and strategy sessions in Rishikesh serene surroundings. ",
       link: "/tour-package-data"
  },
      {
        title: "Lonavala Conference Escape",
        img: LonavalaConferenceEscape,
        desc:
          "Combine business meetings with scenic relaxation in Lonavala peaceful hills. ",
       link: "/tour-package-data"
  },
      {
        title: "Jaipur Business Networking Tour",
        img: JaipurBusinessNetworkingTour,
        desc:
          "Host professional meetings and networking events in Jaipur royal ambiance.",
       link: "/tour-package-data"
  },
      {
        title: "Kerala Backwater Strategy Retreat",
        img:KeralaBackwaterStrategyRetreat ,
        desc:
          "Plan strategic discussions and brainstorming sessions amidst Kerala tranquil backwaters. ",
       link: "/tour-package-data"
  },
      {
        title: "Manali Corporate Adventure Meet",
        img: ManaliCorporateAdventureMeet,
        desc:
          "Boost morale and productivity with adventure based team activities in Manali scenic mountains. ",
       link: "/tour-package-data"
  },
    {
        title: "Manali Mountain Escape",
        img: ManaliMountainEscape,
        desc:
          "Discover the scenic beauty of Manali surrounded by snow capped peaks and lush valleys. ",
       link: "/tour-package-data"
  },
      {
        title: "Shimla Heritage Retreat",
        img: ShimlaHeritageRetreat,
        desc:
          "Explore the charming streets of Shimla filled with colonial architecture and cool mountain air. ",
       link: "/tour-package-data"
  },
      {
        title: "Ooty Scenic Hills Tour",
        img: OotyScenicHillsTour,
        desc:
          "Experience the beauty of Ooty with rolling tea gardens, misty hills, and serene lakes. ",
       link: "/tour-package-data"
  },
    {
        title: "Darjeeling Tea Paradise",
        img: DarjeelingTeaParadise,
        desc:
            "Visit Darjeeling to witness stunning sunrise views over Kanchenjunga and lush tea plantations. ",
     link: "/tour-package-data"
  },
      {
        title: "Munnar Green Valley Escape",
        img: MunnarGreenValleyEscape,
       desc:
          "Explore the rolling green hills of Munnar covered with endless tea estates and misty landscapes.",
       link: "/tour-package-data"
  },
    {
        title: "Nainital Lake View Holiday",
        img: NainitalLakeViewHoliday,
        desc:
            "Relax in Nainital surrounded by beautiful lakes and scenic mountains. ",
     link: "/tour-package-data"
  },
    {
        title: "Maldives Escape",
        img: MaldivesEscape,
        desc:
            "Experience crystal clear turquoise waters and soft white sandy beaches in the Maldives. ",
     link: "/tour-package-data"
  },
    {
        title: "Goa Beach Retreat",
        img: GoaBeachRetreat,
        desc:
            "Discover Goa’s golden beaches, vibrant nightlife, and delicious seafood cuisine. Enjoy exciting water sports, relaxing beachside cafes, and scenic sunset walks along the shore. ",
     link: "/tour-package-data"
  },
      {
        title: "Bali Paradise",
        img: BaliParadise,
        desc:
          "Explore Bali’s stunning coastline surrounded by lush greenery and dramatic cliffs.  ",
       link: "/tour-package-data"
  },
      {
        title: "Phuket Adventure",
        img: PhuketAdventure,
        desc:
          "Enjoy Phuket’s crystal clear waters and exciting island hopping tours. Discover hidden lagoons, limestone cliffs, and vibrant marine life while snorkeling. ",
       link: "/tour-package-data"
  },
      {
        title: "Santorini Seaside",
        img: SantoriniSeaside,
        desc:
          "Experience Santorini’s sparkling blue waters and unique volcanic beaches. Wander through charming white villages overlooking the sea and witness breathtaking sunsets. ",
       link: "/tour-package-data"
  },
      {
        title: "Hawaii Coastal Bliss",
        img: HawaiiCoastalBliss,
        desc:
          "Immerse yourself in Hawaii’s scenic beaches and vibrant island traditions. Surf gentle waves, hike lush trails, and relax under swaying palm trees. ",
      link: "/tour-package-data"
  },
     {
        title: "African Savannah Safari",
        img: AfricanSavannahSafari,
        desc:
          "Explore the vast African savannah filled with majestic lions, elephants, and giraffes roaming freely.",
       link: "/tour-package-data"
  },
      {
        title: "Ranthambore Tiger Safari",
        img: RanthamboreTigerSafari,
        desc:
          "Experience the excitement of spotting royal Bengal tigers in Ranthambore National Park. ",
      link: "/tour-package-data"
  },
      {
        title: "Kaziranga Wildlife Expedition",
        img: KazirangaWildlifeExpedition,
        desc:
          "Visit Kaziranga National Park to witness rare one horned rhinoceroses and vibrant bird species. ",
      link: "/tour-package-data"
  },
      {
        title: "Amazon Rainforest Journey",
        img:AmazonRainforestJourney,
        desc:
          "Explore the rich biodiversity of the Amazon rainforest filled with exotic animals and lush greenery. ",
       link: "/tour-package-data"
  },
      {
        title: "Jim Corbett Jungle Safari",
        img:JimCorbettJungleSafari ,
        desc:
          "Discover the beauty of Jim Corbett National Park while spotting deer, elephants, and elusive tigers. ",
       link: "/tour-package-data"
  },
      {
        title: "Serengeti Migration Tour",
        img: SerengetiMigrationTour,
        desc:
          "Witness the spectacular Great Migration in Serengeti as thousands of wildebeest and zebras travel across vast plains. ",
       link: "/tour-package-data"
  },
     {
        title: "Varanasi Spiritual Journey",
        img: VaranasiSpiritualJourney,
        desc:
          "Experience the spiritual essence of Varanasi with sacred river rituals and ancient temples. ",
      link: "/tour-package-data"
  },
      {
        title: "Golden Temple Visit",
        img: GoldenTempleVisit,
        desc:
          "Visit the serene Golden Temple and experience spiritual harmony through prayer and community service. ",
       link: "/tour-package-data"
  },
      {
        title: "Kedarnath Pilgrimage",
        img: KedarnathPilgrimage,
        desc:
          "Embark on a sacred journey to Kedarnath surrounded by majestic Himalayan landscapes. ",
       link: "/tour-package-data"
  },
      {
        title: "Tirupati Temple Tour",
        img: TirupatiTempleTour,
        desc:
          "Discover divine blessings at Tirupati Temple while experiencing vibrant devotional traditions and peaceful surroundings. ",
       link: "/tour-package-data"
  },
      {
        title: "Mecca Umrah Journey",
        img: MeccaUmrahJourney,
        desc:
          "Undertake a spiritually fulfilling Umrah journey to Mecca filled with prayer and devotion.",
      link: "/tour-package-data"
  },
      {
        title: "Bodh Gaya Meditation Tour",
        img: BodhGayaMeditationTour,
        desc:
          "Visit Bodh Gaya, the place of enlightenment, and experience peaceful meditation sessions.",
       link: "/tour-package-data"
  },
     {
        title: "Himalayan Budget Trek",
        img: HimalayanBudgetTrek,
        desc:
          "Embark on a budget friendly Himalayan backpacking trek filled with scenic mountain trails and peaceful villages. ",
       link: "/tour-package-data"
  },
      {
        title: "Southeast Asia Explorer",
        img: SoutheastAsiaExplorer,
        desc:
          "Travel across vibrant Southeast Asian destinations with affordable stays and local transport. ",
       link: "/tour-package-data"
  },
      {
        title: "European Rail Journey",
        img: EuropeanRailJourney,
        desc:
          "Explore iconic European cities using scenic rail routes and budget hostels. ",
       link: "/tour-package-data"
  },
      {
        title: "Coastal Backpack Trail",
        img: CoastalBackpackTrail,
        desc:
          "Walk along stunning coastal trails carrying your essentials and enjoying breathtaking ocean views. ",
       link: "/tour-package-data"
  },
      {
        title: "Desert Nomad Route",
        img:DesertNomadRoute ,
        desc:
          "Experience a raw and authentic desert backpacking trip across golden dunes and remote settlements. ",
      link: "/tour-package-data"
  },
      {
        title: "South American Adventure",
        img: SouthAmericanAdventure,
        desc:
          "Backpack through vibrant South American landscapes filled with mountains and colorful towns. ",
      link: "/tour-package-data"
  },
    {
        title: "Coastal Highway Drive",
        img:CoastalHighwayDrive,
        desc:
          "Embark on a scenic coastal highway road trip filled with ocean views and refreshing sea breeze. ",
       link: "/tour-package-data"
  },
      {
        title: "Mountain Pass Adventure",
        img: MountainPassAdventure,
        desc:
          "Drive through winding mountain passes surrounded by breathtaking landscapes and cool fresh air. ",
       link: "/tour-package-data"
  },
      {
        title: "Desert Exploration Journey",
        img: DesertExplorationJourney,
        desc:
          "Experience a unique desert road trip across vast golden landscapes and endless horizons. ",
       link: "/tour-package-data"
  },
      {
        title: "Countryside Scenic Route",
        img: CountrysideScenicRoute,
        desc:
          "Enjoy a relaxing countryside road trip through green fields and peaceful villages. ",
       link: "/tour-package-data"
  },
      {
        title: "Forest Trail Drive",
        img: ForestTrailDrive,
        desc:
          "Take a thrilling drive through dense forests surrounded by tall trees and natural beauty. ",
       link: "/tour-package-data"
  },
      {
        title: "Lakeview Road Escape",
        img: LakeviewRoadEscape,
        desc:
          "Travel along serene lake routes offering stunning reflections and calm waters. ",
       link: "/tour-package-data"
  },
     {
        title: "Cozy Hill Station Escape",
        img: CozyHillStationEscape,
        desc:
          "Enjoy a peaceful weekend in a scenic hill station surrounded by cool weather and lush greenery.",
      link: "/tour-package-data"
  },
      {
        title: "Beachside Relaxation",
        img:BeachsideRelaxation,
        desc:
          "Spend your weekend by the beach enjoying golden sands and calming ocean waves. ",
       link: "/tour-package-data"
  },
      {
        title: "Countryside Farm Retreat",
        img:CountrysideFarmRetreat ,
        desc:
          "Escape city life with a charming countryside farm stay filled with fresh air and open fields. .",
      link: "/tour-package-data"
  },
      {
        title: "City Break Adventure",
        img:CityBreakAdventure,
        desc:
          "Explore a vibrant city during a short weekend break packed with sightseeing and shopping.",
       link: "/tour-package-data"
  },
      {
        title: "Lakeview Serenity Trip",
        img: LakeviewSerenityTrip,
        desc:
          "Unwind beside a tranquil lake surrounded by scenic beauty and peaceful vibes.",
      link: "/tour-package-data"
  },
      {
        title: "Forest Camping Getaway",
       img: ForestCampingGetaway,
        desc:
          "Reconnect with nature through a short forest camping adventure filled with hiking and campfire nights.",
       link: "/tour-package-data"
  },
      {
        title: "Maldives Private Villa",
       img: MaldivesPrivateVilla,
        desc:
          "Indulge in a luxurious Maldives escape featuring private overwater villas, crystal clear lagoons, and personalized butler service.",
       link: "/tour-package-data"
  },
      {
        title: "Dubai Royal Experience",
        img:DubaiRoyalExperience,
        desc:
          "Experience unmatched luxury in Dubai with five star hotels, private yacht tours, and premium desert safaris. ",
       link: "/tour-package-data"
  },
      {
        title: "Swiss Luxury Retreat",
        img: SwissLuxuryRetreat,
        desc:
          "Escape to the Swiss Alps in elegant chalets surrounded by breathtaking mountain scenery. ",
       link: "/tour-package-data"
  },
      {
        title: "Paris Elite Getaway",
        img: ParisEliteGetaway,
        desc:
          "Discover Paris in style with luxury suites, private city tours, and exclusive dining experiences.",
       link: "/tour-package-data"
  },
      {
        title: "Bali Premium Resort Stay",
        img: BaliPremiumResortStay,
        desc:
          "Relax in a private pool villa in Bali surrounded by lush greenery and ocean views. ",
       link: "/tour-package-data"
  },
      {
        title: "Santorini Luxury Escape",
        img: SantoriniLuxuryEscape,
        desc:
          "Enjoy breathtaking sunsets from cliffside suites in Santorini with infinity pools and world class service. ",
      link: "/tour-package-data"
  },
      {
        title: "Mountain Trekking Expedition",
        img:MountainTrekkingExpedition ,
        desc:
          "Challenge yourself with an exciting mountain trekking expedition through scenic trails and breathtaking landscapes. ",
      link: "/tour-package-data"
  },
      {
        title: "River Rafting Adventure",
        img: RiverRaftingAdventure,
        desc:
          "Feel the adrenaline rush while navigating powerful river rapids with your team. ",
      link: "/tour-package-data"
  },
      {
        title: "Desert Safari Experience",
        img:DesertSafariExperience,
        desc:
          "Explore vast golden dunes with an exhilarating desert safari ride. ",
       link: "/tour-package-data"
  },
      {
        title: "Scuba Diving Journey",
       img: ScubaDivingJourney,
       desc:
          "Dive into crystal clear waters and discover vibrant marine life beneath the ocean surface. ",
       link: "/tour-package-data"
  },
      {
        title: "Forest Camping Retreat",
       img: ForestCampingRetreat,
       desc:
          "Reconnect with nature through an adventurous forest camping experience. ",
 link: "/tour-package-data"
  },
      {
        title: "Skydiving Thrill",
        img: SkydivingThrill,
        desc:
          "Experience the ultimate adrenaline rush with a breathtaking skydiving adventure. ",
      link: "/tour-package-data"
  },
      {
        title: "Maldives Romantic Escape",
        img: MaldivesRomanticEscape,
        desc:
          "Celebrate your love in the Maldives with crystal clear waters, luxurious overwater villas, and private candlelight dinners by the beach.",
       link: "/tour-package-data"
  },
      {
        title: "Paris Love Journey",
        img:ParisLoveJourney,
        desc:
          "Explore the romantic streets of Paris filled with charming cafes, iconic landmarks, and beautiful river cruises. ",
       link: "/tour-package-data"
  },
      {
        title: "Bali Bliss Retreat",
        img: BaliBlissRetreat,
        desc:
          "Experience a magical honeymoon in Bali surrounded by lush greenery, serene beaches, and private pool villas. ",
      link: "/tour-package-data"
  },
      {
        title: "Santorini Sunset Romance",
        img: SantoriniSunsetRomance,
        desc:
          "Witness stunning sunsets over whitewashed cliffs in Santorini while enjoying peaceful seaside views. ",
       link: "/tour-package-data"
  },
      {
        title: "Swiss Alpine Getaway",
        img:SwissAlpineGetaway ,
        desc:
          "Escape to the Swiss Alps for breathtaking mountain views, cozy chalets, and scenic train journeys. ",
       link: "/tour-package-data"
  },
      {
        title: "Hawaii Island Romance",
        img:HawaiiIslandRomance,
        desc:
          "Immerse yourselves in Hawaii’s tropical beauty with golden beaches, scenic waterfalls, and vibrant island traditions. ",
       link: "/tour-package-data"
  },
      {
        title: "Mountain Adventure Camp",
        img: MountainAdventureCamp,
        desc:
          "Experience thrilling mountain adventures with your group surrounded by breathtaking landscapes and fresh air. Enjoy trekking, campfire nights, team building games, and scenic sunrise views. ",
      link: "/tour-package-data"
  },
      {
        title: "Beach Fun Getaway",
        img: BeachFunGetaway,
        desc:
          "Enjoy a lively beach vacation filled with sunshine, water sports, and relaxing seaside moments. ",
       link: "/tour-package-data"
  },
      {
        title: "City Exploration Tour",
        img:CityExplorationTour,
        desc:
          "Discover vibrant city life with guided tours, cultural landmarks, and exciting nightlife. ",
     link: "/tour-package-data"
  },
      
    {
        title: "Wildlife Safari Trip",
        img: WildlifeSafariTrip,
        desc:
            "Embark on an exciting wildlife safari adventure with your group through scenic forests and national parks.  ",
    link: "/tour-package-data"
  },
     {
        title: "Island Hopping Tour",
        img: IslandHoppingTour,
        desc:
          "Explore beautiful islands with crystal clear waters and sandy beaches.  .",
      link: "/tour-package-data"
  },
      {
        title: "Cultural Heritage Journey",
        img: CulturalHeritageJourney,
        desc:
          "Travel together to explore historical monuments, traditional villages, and rich cultural heritage sites. ",
       link: "/tour-package-data"
  },
      {
        title: "Hill Station Retreat",
        img:HillStationRetreat,
        desc:
          "Enjoy a refreshing hill station vacation with cool weather, scenic mountain views, and peaceful surroundings. ",
       link: "/tour-package-data"
  },
      {
        title: "Theme Park Adventure",
        img:ThemeParkAdventure,
        desc:
          "Experience thrilling rides, exciting attractions, and fun filled entertainment at a popular theme park. .",
       link: "/tour-package-data"
  },
      {
        title: "Beachside Family Escape",
        img:BeachsideFamilyEscape,
        desc:
          "Relax on sandy beaches while children build sandcastles and adults unwind by the waves. ",
       link: "/tour-package-data"
  },
      {
        title: "Cultural Heritage Tour",
        img:CulturalHeritageTour,
        desc:
          "Explore historical landmarks, ancient monuments, and vibrant local traditions together. ",
       link: "/tour-package-data"
  },
      {
        title: "Wildlife Nature Trip",
        img:WildlifeNatureTrip,
        desc:
          "Discover wildlife reserves and scenic forests while spotting fascinating animals in their natural habitat.",
      link: "/tour-package-data"
  },
      {
        title: "Countryside Farm Stay",
        img:CountrysideFarmStay,
        desc:
          "Experience rural life with farm activities, fresh air, and open green landscapes.",
       link: "/tour-package-data"
  },
  {
    img: pkg1,
    title: "Indore–Ujjain–Omkareshwar",
    days: "3Days/2Nights",
    price: "6,999/Person",
    
    extra: "Cab+Hotel+Sightseeing",
     link: "/tour-package-data"
  },
  {
    img: pkg2,
    title: "Shimla–Manali Tour",
    days: "5Days/4Nights",
    price: "14,999/person",
     link: "/tour-package-data"
  },
  {
    img: pkg3,
    title: "Delhi–Jaipur",
    days: "3Days/2Nights",
    price: "7,999/Person",
     link: "/tour-package-data"
  },
  {
    img: pkg4,
    title: "Goa–Beach Holiday",
    days: "4Days/3Nights",
    price: "12,999/Person",
     link: "/tour-package-data"
  },
  {
    img: pkg5,
    title: "Delhi–Jaipur",
    days: "3Days/2Nights",
    price: "7,999/Person",
     link: "/tour-package-data"
  },
  {
    img: pkg6,
    title: "Punjab Tour",
    days: "5Days/4Nights",
    price: "14,999/person",
     link: "/tour-package-data"
  },
  {
    img: ttvsolo,
    title: "Solo Trip",
    desc: "Travel alone explore yourself freedom growth adventure peace self discovery",
     link: "/tour-package-data",

  },
  {
    img: ttvfamily,
    title: "Family Trip",
    desc: "Fun bonding time kids elders memories laughter games sightseeing together",
     link: "/tour-package-data",
  },
  {
    img: ttvgroup,
    title: "Group Trip",
    desc: "Friends together parties roadtrips fun photos music adventure unforgettable memories",
     link: "/tour-package-data",
  },
  {
    img: ttvhoneymoon,
    title: "Honeymoon Trip",
    desc: "Romantic escapes candle dinners beaches resorts privacy love beautiful moments",
     link: "/tour-package-data",
  },
  {
    img: ttvadventure,
    title: "Adventure Trip",
    desc: "Trekking rafting camping biking mountains thrill adrenaline outdoor challenges",
     link: "/tour-package-data",
  },
  {
    img: ttvluxury,
    title: "Luxury Trip",
    desc: "Premium hotels private transfers comfort spa fine dining exclusive experiences",
    link: "/tour-package-data",
  },
  {
    img: ttvweekend,
    title: "Weekend Getaway",
    desc: "Short breaks quick travel relax recharge explore nearby destinations fun",
    link: "/tour-package-data",
  },
  {
    img: ttvroad,
    title: "Road Trip",
    desc: "Drive highways music snacks scenic stops freedom friends endless stories",
     link: "/tour-package-data",
  },
  {
    img: ttvbackpacking,
    title: "Backpacking Trip",
    desc: "Budget stays hostels public transport culture food local adventures",
     link: "/tour-package-data",
  },
  {
    img: ttvspiritual,
    title: "Religious Trip",
    desc: "Temples meditation yoga peace rituals prayers faith healing soulful journey",
   link: "/tour-package-data",
  },
  {
    img: ttvwild,
    title: "Wildlife Safari",
    desc: "Forests animals photography jeep safari nature birds thrilling sightings",
     link: "/tour-package-data",
  },
  {
    img: ttvbeach,
    title: "Beach Holiday",
    desc: "Sun sand waves resorts seafood sunsets relaxation recognizing coastal beauty",
    link: "/tour-package-data",
  },
  {
    img: ttvhill,
    title: "Hill Station Trip",
    desc: "Cool weather mountains valleys waterfalls walks cozy cafes peaceful views",
     link: "/tour-package-data",
  },
  {
    img: ttvcorporate,
    title: "Corporate Trip",
    desc: "Team outings meetings workshops bonding fun activities retreats productivity",
     link: "/tour-package-data",
  },
  {
    img: ttvcouple,
    title: "Couple Trip",
    desc: "Romantic strolls cafes sunsets conversations bonding memories cozy evenings",
     link: "/tour-package-data",
  },
  {
    img: ttvfestival,
    title: "Festival Trip",
    desc: "Celebrate local festivals colors dances food music traditions cultural immersion",
     link: "/tour-package-data",
  },
    {
        title: "Religious Tour",
        img: rtour,
        desc: "Religious tours offer a deeply spiritual and culturally enriching journey through some of the most sacred destinations. ",
     link: "/tour-package-data"
  },
  {
    title: "Solo Trip",
    img: stour,
    desc: "A solo trip is the perfect way to discover yourself while exploring the world at your own pace. ",
     link: "/tour-package-data",
  },
  {
    title: "Weekend Getaway",
    img: wtour,
    desc: "Weekend getaways are short yet refreshing escapes designed to break the routine of everyday life.",
     link: "/tour-package-data",
  },
  {
    title: "Explore Beach",
    img: etour,
    desc: "Beach tours invite you to unwind beside golden sands, sparkling blue waters, and breathtaking sunsets.",
    link: "/tour-package-data",
  },
  {
    title: "Group Trip",
    img: gtour,
    desc: "Group trips are all about sharing laughter, stories, and unforgettable experiences with friends, family, or colleagues. ",
     link: "/tour-package-data",
  },
  {
    title: "Honeymoon Trip",
    img: htour,

    desc: "A honeymoon trip is a once in a lifetime celebration of love and new beginnings.",
     link: "/tour-package-data",
  },
  {
    title: "Road Trip",
    img: rotour,
    desc: "A road trip is all about freedom, adventure, and spontaneous exploration. ",
    link: "/tour-package-data",
  },
  {
    title: "Couple Trip",
    img: ctour,
    desc: "A couple trip offers the perfect opportunity to reconnect, relax, and create unforgettable memories together.",
    link: "/tour-package-data",
  },
  {
    title: "Festival Trip",
    img: fetour,
    desc: "A festival trip immerses travelers in vibrant celebrations filled with color, music, dance, and cultural traditions.",
    link: "/tour-package-data",
  },
  {
    title: "Family Trip",
    img: ftour,
    desc: "A family trip brings everyone together to share laughter, adventure, and meaningful moments. .",
     link: "/tour-package-data",
  },
  { img: shimla, title: "Shimla", days: "7 Days - All-Inclusive", link: "/tour-package-data" },
  { img: udaipur, title: "Udaipur", days: "5 Days - Adventure", link: "/tour-package-data" },
  { img: jaisalmer, title: "Jaisalmer", days: "3 Days - Cultural", link: "/tour-package-data" },

  { img: manali, title: "Manali", days: "6 Days - Snow Fun", link: "/tour-package-data" },
  { img: goa, title: "Goa", days: "4 Days - Beach Holiday", link: "/tour-package-data" },
  { img: kerala, title: "Kerala", days: "5 Days - Backwaters", link: "/tour-package-data" },

  { img: ladakh, title: "Ladakh", days: "8 Days - Bike Trip" , link: "/tour-package-data"},
  {
    img: rishikesh,
    tag: "Spiritual",
    title: "Rishikesh",
    days: "3 Days - Yoga Retreat",
     link: "/tour-package-data"
  },
  {
    img: andaman,
    tag: "Island",
    title: "Andaman",
    days: "6 Days - Island Escape",
     link: "/tour-package-data"
  },

  {
    img: manali,
    title: "Manali",
    days: "6 Days - Romantic Escape",
     link: "/tour-package-data"
  },
  {
    img: goa,
    title: "Goa",
    days: "4 Days - Beach Stay",
  },
  {
    img: kerala,
    title: "Kerala",
    days: "5 Days - Backwater Cruise",
     link: "/tour-package-data"
  },

  {
    img: ooty,
    title: "Ooty",
    days: "5 Days - Family Fun",
     link: "/tour-package-data"
  },
  {
    img: darjeeling,
    title: "Darjeeling",
    days: "4 Days - Nature Tour",
     link: "/tour-package-data"
  },
  {
    img: jaipur,
    title: "Jaipur",
    days: "3 Days - Heritage Trip",
     link: "/tour-package-data"
  },

  {
    img: rishikesh,
    title: "Rishikesh",
    days: "4 Days - River Rafting",
     link: "/tour-package-data"
  },
  {
    img: ladakh,
    title: "Ladakh",
    days: "7 Days - Bike Trip",
     link: "/tour-package-data"
  },
  {
    img: spiti,
    title: "Spiti Valley",
    days: "6 Days - Road Trip",
     link: "/tour-package-data"
  },

  {
    img: rishikesh,

    title: "Rishikesh",
    days: "4 Days – River Rafting & Camping",
     link: "/tour-package-data"
  },
  {
    img: coorg,

    title: "Coorg",
    days: "5 Days – Coffee Trails Retreat",
     link: "/tour-package-data"
  },
  {
    img: varanasi,

    title: "Varanasi",
    days: "3 Days – Ganga Aarti Experience",
     link: "/tour-package-data"
  },
  {
    img: darjeeling,

    title: "Darjeeling",
    days: "6 Days – Tea Gardens & Toy Train",
     link: "/tour-package-data"
  },
  {
    img: meghalaya,

    title: "Meghalaya",
    days: "7 Days – Waterfalls & Living Roots",
     link: "/tour-package-data"
  },
  {
    img: ranthambore,

    title: "Ranthambore",
    days: "3 Days – Tiger Safari Adventure",
     link: "/tour-package-data"
  },
  {
    img: pondicherry,

    title: "Pondicherry",

    days: "4 Days – French Town Escape",
     link: "/tour-package-data"
  },
  {
    img: mysore,

    title: "Mysore",
    days: "3 Days – Palace & Culture Tour",
     link: "/tour-package-data"
  },
  {
    img: spiti,

    title: "Spiti Valley",
    days: "8 Days – Himalayan Road Journey",
     link: "/tour-package-data"
  },

  {
    img: andaman,
    title: "Andaman",
    days: "5 Days - Scuba Diving",
     link: "/tour-package-data"
  },
  {
    img: kasol,
    title: "Kasol",
    days: "4 Days - Trekking",
     link: "/tour-package-data"
  },
  {
    img: meghalaya,
    title: "Meghalaya",
    days: "6 Days - Cave Exploration",
     link: "/tour-package-data"
  },

  {
    img: varanasi,
    title: "Varanasi",
    days: "3 Days - Temple Visit",
     link: "/tour-package-data"
  },
  {
    img: rameshwaram,
    title: "Rameshwaram",
    days: "4 Days - Pilgrimage",
     link: "/tour-package-data"
  },
  {
    img: tirupati,
    title: "Tirupati",
    days: "2 Days - Darshan Tour",
     link: "/tour-package-data"
  },
  { img: delhiagra, title: "Delhi - Agra", days: "3 Days 2 Nights", link: "/tour-package-data" },
  { img: delhimandu, title: "Jaipur", days: "2 Days 1 Night" , link: "/tour-package-data"},
  { img: delhiudaipur, title: "Udaipur", days: "2 Days 1 Night", link: "/tour-package-data" },
  { img: delhirishikesh, title: "Rishikesh", days: "2 Days 1 Night", link: "/tour-package-data" },
  { img: delhishimla, title: "Manali", days: "3 Days 2 Nights", link: "/tour-package-data" },

  {
    img: agra,
    title: "Agra",
    desc: "Home to world-famous monuments and rich Mughal legacy.",
     link: "/tour-package-data"
  },
  {
    img: delhi,
    title: "Delhi",
    desc: "A dynamic blend of ancient heritage and modern city life.",
     link: "/tour-package-data"
  },
  {
    img: kashmir,
    title: "Kashmir",
    desc: "Breathtaking landscapes wrapped in peace and timeless beauty.",
     link: "/tour-package-data"
  },
  {
    img: holi,
    title: "Holi",
    desc: "All Over India",
    extra: "March",
     link: "/tour-package-data"
  },
  {
    img: gurunanak,
    title: "Guru nanak jayanti",
    desc: "All Over India",
    extra: "October-November",
     link: "/tour-package-data"
  },
  {
    img: eid,
    title: "Eid-ul-fitr",
    desc: "All Over India",
    extra: "Feb-April",
     link: "/tour-package-data"
  },
  {
    img: christmas,
    title: "Christmas",
    desc: "All Over India",
    extra: "25 December",
     link: "/tour-package-data"
  },
  {
    img: nityanjali,
    title: "Nityanjali",
    desc: "Tamil Nadu",
    extra: "Dance and Feb",
     link: "/tour-package-data"
  },
  {
    img: ramnavami,
    title: "Ram Navami",
    desc: "All Over India",
    extra: "Festival and March-April",
     link: "/tour-package-data"
  },

  {
    img: durgapuja,
    title: "Durga Puja",
    desc: "All Over India",
    extra: "Festival and Sep-Oct",
     link: "/tour-package-data"
  },
  {
    img: chathpuja,
    title: "Chhath Puja",
    desc: "Bihar",
    extra: "Festival and Oct-Nov",
     link: "/tour-package-data"
  },
  {
    img: waterpark,
    title: "Water Park",
    desc: "Park Fun, Relaxation, and Thrilling Water Activities.",
     link: "/tour-package-data"
  },
  {
    img: gamingzone,
    title: "Gaming Zone",
    desc: "Technology, Competition, and Immersive Experiences.",
     link: "/tour-package-data"
  },
  {
    img: adventurepark,
    title: "Adventure Park",
    desc: "Thrilling Experiences, Outdoor Activitiesand Challenges.",
     link: "/tour-package-data"
    },
    {
      img: ManaliSoloEscape,
      title: "Manali Solo Escape",
      desc: "Spend peaceful mornings in the mountains, explore hidden cafes, walk through pine forests.",
     link: "/tour-package-data"
  },
    {
      img:RishikeshRetreat ,
      title: "Rishikesh Retreat",
      desc: "Practice yoga by the Ganga, attend meditation sessions, try thrilling river rafting.",
     link: "/tour-package-data"
  },
    {
      img:GoaBackpacking,
     title: "Goa Backpacking",
      desc: "Relax on sunny beaches, stay in hostels, meet international travelers, ride scooters across coastal roads.",
     link: "/tour-package-data"
  },
    {
      img: LadakhRoadAdventure,
     title: "Ladakh Road Adventure",
      desc: "Ride through dramatic landscapes, cross high mountain passes, visit peaceful monasteries.",
     link: "/tour-package-data"
  },
    {
      img: DarjeelingHillsWalk,
      title: "Darjeeling Hills Walk",
      desc: "Wake up to misty mornings, stroll through tea gardens, enjoy toy train rides.",
       link: "/tour-package-data"
    },
    {
      img: PondicherryExplorer,
      title: "Pondicherry Explorer",
      desc: "Cycle through French streets, relax at peaceful beaches, visit cozy cafes.",
       link: "/tour-package-data"
    },
];

const TourPackagesViewMore = () => {
  const navigate = useNavigate();
  return (
    <div className="packages-section">
      {/* Heading Row */}
      

      {/* Grid */}
      <div className="packages-grid">
        {packages.map((item) => (
          <div className="package-card" onClick={() =>
            navigate(item.link, {
              state: { title: item.title },
            })
          }>
            <img src={item.img} alt={item.title} />

            <div className="package-content">
                    {item.title && <h3>{item.title}</h3>}
                    {item.days && <p>{item.days}</p>}
                    {item.price && <p>{item.price}</p>}
              {item.extra && <p>{item.extra}</p>}
                    {item.desc && <p>{item.desc}</p>}
              
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TourPackagesViewMore;
